import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  data: function data() {
    return {
      loginForm: {
        username: 'wxx655164212112',
        password: 'f51fd99d13accd8f50688c356ce8b0ef',
        timestamp: '20210125093519002',
        rememberMe: true
      },
      sourceUrl: '' // 来源url

    };
  },
  mounted: function mounted() {
    this.hasToken();
  },
  methods: {
    hasToken: function hasToken() {
      var _this = this;

      this.sourceUrl = document.referrer;
      var urlParamObj = this.$route.query;
      this.loginForm.username = urlParamObj.account;
      this.loginForm.password = urlParamObj.sign;
      this.loginForm.timestamp = urlParamObj.timestamp;
      var loginFormClone = JSON.parse(JSON.stringify(this.loginForm));
      this.$store.dispatch('LoginByUsername', loginFormClone).then(function (res) {
        if (res.data.code === 200) {
          _this.$router.push('/');

          _this.$store.dispatch('ResetRouters', null).then(function () {}); // 重置左侧侧边栏


          _this.$store.dispatch('ChooseRouters', null).then(function () {}).catch(function () {
            console.log('重置左侧菜单失败');
          });
        } else {
          setTimeout(function () {
            window.location.replace(_this.sourceUrl);
          }, 1500);
        }
      });
    }
  }
};